import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import editIcon from '../../assets/edit.png';
import { createMuiTheme, MuiThemeProvider, Switch, Menu, InputAdornment, Typography, Tooltip, withStyles, Snackbar, TextField } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import DetailPoliklinik from './detaiPoli';
import AddSpesialis from './addSpesialis';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import filterIcon from '../../assets/ic_search@3x.png';
import Loader from 'react-loader-spinner'
import { Visibility, VisibilityOff } from '@material-ui/icons';
import Password from '../../assets/ic_pass.png';
import { useHistory, useLocation } from 'react-router-dom';
import ErrorRequest from '../ErrorRequest';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()
const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

export default function DetailAkun(props) {
    const location = useLocation()
    const history = useHistory()
    const [editable, setEditable] = React.useState(false)
    const [value, setValue] = React.useState([])
    const [idAkun, setIdAkun] = React.useState(0)
    const [name, setName] = React.useState("")
    const [noHp, setNoHp] = React.useState(location.state.data.phone)
    const [email, setEmail] = React.useState("")
    const [alamat, setAlamat] = React.useState("")
    const [status, setStatus] = React.useState("")
    const [statusEdit, setStatusEdit] = React.useState(location.state.data.status)
    const [detail, setDetail] = React.useState([])
    const [data, setData] = React.useState([])
    const [messageError, setMessageError] = React.useState(null)
    const [visibleError, setVisibleError] = React.useState(false)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [visibleReset, setVisibleReset] = React.useState(false);
    const [newPassword, setNewPassword] = React.useState("");
    const [showPass, setShowPass] = React.useState(false);
    console.log(location);
    console.log(status);
    const id = location.state.data.id

    React.useEffect(() => {
        getDetail()
        if (statusEdit !== null) {
            let indexStatus = listStatus.findIndex((val) => val.id === location.state.data.status)
            setStatusEdit(listStatus[indexStatus])
            console.log(status);
            console.log(indexStatus);
        }
    }, [])

    console.log(statusEdit);

    const listStatus = [
        {name: "Terverifikasi", id: 1},
        {name: "Belum Verifikasi", id: 0},
    ]

    const getDetail = () => {
        api.create().detailAkun(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setData(response.data.data)
                    setDetail(response.data.data)
                    setName(response.data.data.name)
                    setEmail(response.data.data.email)
                    setIdAkun(response.data.data.id)
                    setNoHp(response.data.data.phone === null ? 'Belum Terdaftar' : response.data.data.phone)
                    setAlamat(response.data.data.address === null ? 'Belum Terdaftar' : response.data.data.address)
                    setStatus(response.data.data.status === 1 ? "Terverifikasi" : "Belum Terverifikasi")
                }
            }
        })
    }
    console.log(detail);

    const handleEdit = () => {
        setEditable(true)
    }
    
    const handleBatal = () => {
        setEditable(false)
    }

    const handleSubmit = () => {
        let formData = new FormData();
        formData.append('id', id)
        formData.append('name', name)
        formData.append('phone', noHp)
        formData.append('email', email)
        formData.append('address', alamat)
        formData.append('status', statusEdit.id)
        api.create().editAkun(formData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setMessageAlert("Edit Berhasil!")
                    setOpenAlert(true)
                    setStatusAlert("succes")
                    setEditable(false)
                    getDetail()
                } else {
                    setMessageError(response.data.data)
                    setVisibleError(true)
                }
            }
        })
    }

    const handleClik = (item) => {
        setValue(item)
        setIdAkun(item.id)
        setNoHp(item.phone)
        setAlamat(item.address)
        setStatus(item.status === 1 ? "Terverifikasi" : "Belum Terverifikasi")
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const handleResetPassword = () => {
        let formData = new FormData();
        formData.append('id', id);
        formData.append('password', newPassword);
        api.create().editAkun(formData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setMessageAlert("Edit Berhasil!")
                    setOpenAlert(true)
                    setStatusAlert("succes")
                    setVisibleReset(false)
                } else {
                    setMessageError(response.data.data)
                    setVisibleError(true)
                }
            }
        })
    }

    console.log(value);

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ paddingTop: 20, paddingLeft: 0, width: "30%", backgroundColor: 'transparent', marginTop: 10, borderRadius: 10, }}>
                <div style={{ width: 80, height: 80, backgroundColor: 'transparent', borderRadius: 80, marginBottom: 10 }}>
                    <img src={data.media_path} style={{ width: 80, height: 80, marginTop: 3, borderRadius: 60 }} />
                </div>
                <Typography>List Pasien</Typography>
                {
                    detail.patient && detail.patient.map((el, idx) => {
                        return (
                            <div style={{cursor: 'pointer'}} onClick={() => handleClik(el)}>
                                <Typography style={{color: value === el ? "#278863" : "#b4b4b4", borderLeft: value === el ? "3px solid #278863" : null, borderSpacing: value === el ? "0, 0, 0, 370" : null, paddingLeft: value === el ? 10 : null}}> {el.name} </Typography>
                            </div>
                        )
                    })
                }
            </div>
            <div style={{ paddingTop: 20, width: "65%", marginTop: 10 }}>
                <div>
                    <div style={{ height: 50, width: 200, position: 'relative', left: "68%", cursor: "pointer", display: 'flex', justifyContent: 'space-between' }}>
                        <div onClick={() => handleEdit()} style={{ height: 32, width: 50, backgroundColor: 'transparent', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', border: '2px solid #2a9c6c', color: 'black' }} >
                            <Typography style={{ fontSize: 15, marginTop: 4, textAlign: 'center' }}>Edit</Typography>
                        </div>
                        <div onClick={() => setVisibleReset(true)} style={{ height: 32, width: 150, backgroundColor: 'transparent', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', marginLeft: 20, border: '2px solid #2a9c6c', color: 'black' }} >
                            <Typography style={{ fontSize: 15, marginTop: 4, textAlign: 'center' }}>Reset Password</Typography>
                        </div>
                    </div>
                    <Typography>{value.name}</Typography>
                    {
                        editable === false ?
                            <div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="id"
                                        name="id"
                                        label="ID Akun"
                                        value={idAkun}
                                        InputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                            disableUnderline: true
                                        }}
                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="name"
                                        name="name"
                                        label="Nama Pemilik Akun"
                                        value={name}
                                        InputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                            disableUnderline: true
                                        }}
                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="noHp"
                                        name="noHp"
                                        label="No. Handphone"
                                        value={`${noHp !== null && noHp[0] == 0 ? `+62${noHp.slice(1)}` : `+62${noHp}`}`}
                                        InputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                            disableUnderline: true
                                        }}
                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="email"
                                        name="email"
                                        label="Email"
                                        value={email}
                                        InputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                            disableUnderline: true
                                        }}
                                    />
                                </div>
                                {/* <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="address"
                                        name="address"
                                        label="Alamat"
                                        value={alamat}
                                        InputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                            disableUnderline: true
                                        }}
                                    />
                                </div> */}
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="status"
                                        name="status"
                                        label="Status"
                                        value={status}
                                        InputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                            disableUnderline: true
                                        }}
                                    />
                                </div>
                            </div>
                            :
                            <div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="id"
                                        name="id"
                                        label="ID Akun"
                                        value={idAkun}
                                        InputProps={{
                                            style: {
                                                fontSize: 14, cursor: 'default'
                                            },
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style:{cursor: 'default'}
                                        }}
                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="name"
                                        name="name"
                                        label="Nama Pemilik Akun"
                                        onChange={(e) => setName(e.target.value)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            }
                                        }}
                                        value={name}
                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="noHp"
                                        name="noHp"
                                        label="No. Handphone"
                                        onChange={(e) => setNoHp(e.target.value)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="end" style={{ marginRight: '10%' }}>+62</InputAdornment>,
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            },
                                        }}
                                        value={`${noHp[0] == 0 ? `${noHp.slice(1)}` : `${noHp}`}`}
                                    />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="email"
                                        name="email"
                                        label="Email"
                                        onChange={(e) => setEmail(e.target.value)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            }
                                        }}
                                        value={email}
                                    />
                                </div>
                                {/* <div className="">
                                    <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="address"
                                        name="address"
                                        label="Alamat"
                                        onChange={(e) => setAlamat(e.target.value)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            }
                                        }}
                                        value={alamat}
                                    />
                                </div> */}
                                <div className="">
                                    <Autocomplete
                                        options={listStatus}
                                        getOptionLabel={(option) => option.name}
                                        disableClearable
                                        style={{ marginTop: 15, width: '40%'}}
                                        // debug
                                        name='antrian'
                                        id="tipe"
                                        onChange={(event, newInputValue) => {
                                            setStatusEdit(newInputValue)
                                            // setAntrian(newInputValue)
                                            // forceUpdate()
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Status"
                                            />
                                        }
                                        value={statusEdit}
                                    />
                                    {/* <TextField
                                        style={{ width: '40%', marginTop: 15 }}
                                        id="status"
                                        name="status"
                                        label="Status"
                                        // onChange={(e) => setStatus(e.target.value)}
                                        inputProps={{
                                            style: {
                                                fontSize: 14, cursor: 'default'
                                            },
                                        }}
                                        InputProps={{
                                            style: {
                                                fontSize: 14
                                            },
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            },
                                        }}
                                        value={status}
                                    /> */}
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div onClick={() => handleBatal()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div onClick={() => handleSubmit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Simpan</Typography>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
                {
                    visibleError ?
                    <ErrorRequest
                        message={messageError}
                        close={() => setVisibleError(false)}
                    />
                    :null
                }
                {
                    visibleReset ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                            <div style={{margin: 'auto'}}>
                                <Typography style={{fontStyle: 'bold', letterSpacing: 1.5, fontFamily: 'poppins', fontSize: 18}}>Ganti Password</Typography>
                            </div>
                            <div>
                                {/* <Typography>{errorMessage}</Typography> */}
                                <div className="">
                                <TextField
                                    style={{ width: '60%', marginTop: 15 }}
                                    id="password"
                                    name="password"
                                    label="Password"
                                    type={showPass ? 'text' : 'password'}
                                    placeholder={"input new password"}
                                    onChange={(e) => {
                                        // setFloor(e.target.value)
                                        setNewPassword(e.target.value)
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="end" style={{ marginRight: '10%' }}><img src={Password} style={{ height: '3vh' }} /></InputAdornment>,
                                        endAdornment: <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                style={{ color: '#4b4b4b', opacity: 0.5, outline: 'none', margin: 0, padding: 0 }}
                                                onClick={() => setShowPass(!showPass)}
                                                edge="end"
                                            >
                                                {showPass ? <Visibility style={{ height: '3vh' }} /> : <VisibilityOff style={{ height: '3vh' }} />}
                                            </IconButton>
                                        </InputAdornment>,
                                    }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                    value={newPassword}
                                />
                        </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: '1.5em' }}>
                                <div 
                                    onClick={() => setVisibleReset(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div 
                                    onClick={() => handleResetPassword()} 
                                    style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlign: 'center' }}>Simpan</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }
            </div>
        </div>
    )

}